import { Button, FormControl, InputLabel, makeStyles, MenuItem, OutlinedInput, Select} from '@material-ui/core';
import { IDefaultDishContent, IDefaultSeatingContent, IOfficeContent, IPriceModelContent, IVersionedObject } from '../../planEatApi/PlanEatFacade';
import { planEatApi } from '../../planEatApi/PlanEatApi';
import { ChangeEvent, useEffect, useState } from 'react';
import { Modal } from '../ui/Modal';
import { InputContainer } from '../ui/InputContainer';
import { CancelCrudButtons } from '../ui/CancelCrudButtons';
import { InputField } from '../ui/InputField';
import toast from 'react-hot-toast';

const useStyles = makeStyles((theme: any) => ({
    inputTitle:{
        fontSize: 18,
        fontWeight: 700,
        paddingBottom: 15
    },
    defaultDishContainer: {
        display: 'flex',
        justifyContent:'start',
        alignItems: 'start',
        marginTop: 35,
    },
    defaultDishButtton: {
        color: 'white',
        background: '#FFFFFF',
        borderRadius: '13px',
        fontSize: '14px',
        fontWeight: 400,
        padding: 15,
        cursor: 'pointer',
        marginRight: 10,
        marginBottom: 10
    },
}));

interface Props {
    office: IOfficeContent;
    defaultSeatingHidden:boolean;
    setDefaultSeatingHidden:  React.Dispatch<React.SetStateAction<any>>;
    defaultSeating: IDefaultSeatingContent | undefined;
    setDefaultSeating: React.Dispatch<React.SetStateAction<any>>;
    postDefaultSeating: (defaultSeating: IDefaultSeatingContent) => void
}

export const DefaultSeatingModal: React.FC<Props> = ({office,defaultSeatingHidden,setDefaultSeatingHidden,defaultSeating,setDefaultSeating,postDefaultSeating}) => {
    // Styling
    const classes = useStyles();

    // State
    const [defaultDishesView,setDefaultDisheView] = useState<any[]>([])
    const [priceModels, setPriceModels] = useState<IVersionedObject<IPriceModelContent>[]>([])
    const [priceModelsView, setPriceModelsView] = useState<any[]>([])


    useEffect(() => {
        getPriceModel()
    },[])
    
    function getPriceModel(){
        planEatApi.getPriceModels()
        .then((response) => {
            setPriceModels(response.data)
        })
        .catch((e) => {
            console.log(e)
        })
    }

    function createDefaultSeating() {
        if(defaultSeating){
            if(defaultSeating.defaultSeatingDishes.length=== 0){
                toast.error("At least one default should be selected")
            } else if (defaultSeating.defaultSeatingPriceModelId=== ""){
                toast.error("Please select a price model")
            } else {
                postDefaultSeating(defaultSeating)            
            }
        }
    }

    const displayDefaultDishes = () => {
        if(defaultSeating){
            var tmpDefaultDishesView : any[] = []
            if(office.defaultDishesContent.length > 0){
                office.defaultDishesContent.forEach((defaultDishContent,index) => {
                    let contains = false;
                    defaultSeating.defaultSeatingDishes.forEach((defaultSeatingDish) => {
                        if(defaultSeatingDish=== defaultDishContent.defaultDishId){
                            contains = true;
                        }
                    })
                    tmpDefaultDishesView.push(
                        <Button key={defaultDishContent.defaultDishId} className={classes.defaultDishButtton} style={{background : contains ? "#6178ED" : "#bfbdbd"}} onClick={() => {handleDefaultDishesChange(defaultDishContent)}}>
                            {index+1}. {defaultDishContent.defaultDishName}
                        </Button>
                    )
                })
            } else {
                tmpDefaultDishesView.push(
                    <div>
                        No default created, please create default dish before creating a default seating. 
                    </div>
                )
            }
            // Check if its the same view
            if(defaultDishesView !== tmpDefaultDishesView){
                setDefaultDisheView(tmpDefaultDishesView)
            }
        }
    }

    useEffect(() => {
        if(defaultSeating){
            displayDefaultDishes()
        }
    },[defaultSeating])

    const handleDefaultDishesChange =  (selectedDefaultDish: IDefaultDishContent) => {
        if(defaultSeating){
            var tmpSelectedDishes : string [] = []

            if(defaultSeating.defaultSeatingDishes.length > 0){
                let contains = false
                defaultSeating.defaultSeatingDishes.forEach((defaultSeatingDish,index) => {
                    if(selectedDefaultDish.defaultDishId=== defaultSeatingDish){
                        contains = true
                    } else {
                        tmpSelectedDishes.push(defaultSeatingDish)
                    }
                })

                if(!contains){
                    tmpSelectedDishes.push(selectedDefaultDish.defaultDishId)
                }
            } else {
                tmpSelectedDishes.push(selectedDefaultDish.defaultDishId)
            }
            // Update deafault seatings
            defaultSeating.defaultSeatingDishes = tmpSelectedDishes
            setDefaultSeating(defaultSeating)
            displayDefaultDishes()
        }
    }

    useEffect(() => {
        displayPriceModelOptions()
    },[priceModels])

    function displayPriceModelOptions(){
        var tmpPriceModelOptionsView : any[] = []
        var priceModelsOnOffice = priceModels.filter(item => item.content.officeId === office.id)
        priceModelsOnOffice.forEach(priceModel => (
            tmpPriceModelOptionsView.push(
                <MenuItem key={priceModel.content.id} value={priceModel.content.id}>{priceModel.content.name}</MenuItem>
            )
        ))
        setPriceModelsView(tmpPriceModelOptionsView)
    }
    const handlePriceModelChange = (prop: keyof IDefaultSeatingContent) => (event: ChangeEvent<{ name?: string | undefined; value: unknown; }>) => {
        setDefaultSeating({ ...defaultSeating, [prop]: event.target.value });
    }

    const handleChange = (prop: keyof IDefaultSeatingContent) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setDefaultSeating({ ...defaultSeating, [prop]: event.target.value });
    };

    return (
        <Modal title={defaultSeating?.defaultSeatingId !== '' ? "Update Default Seating" : "New Default Seating"} hidden={defaultSeatingHidden} setHidden={setDefaultSeatingHidden}>
            {defaultSeating ? 
                <div>
                    <InputContainer>
                        <InputField
                            label="Default Seating Name"
                            id="default-seating-name"
                            variant="outlined"
                            type="text"
                            value={defaultSeating.defaultSeatingName}
                            onChange={handleChange('defaultSeatingName')}
                            placeholder="Default seating name"
                            fullWidth
                        />
                        <InputField
                            label="Default Seating Capacity"
                            variant="outlined"
                            type="number"
                            value={defaultSeating.defaultSeatingCapacity}
                            placeholder="Default Seating Capacity"
                            onChange={handleChange('defaultSeatingCapacity')}
                            fullWidth
                        />
                        <InputField
                            label="Default Seating Start"
                            variant="outlined"
                            id="time"
                            type="time"
                            value={defaultSeating.defaultSeatingStartTime}
                            placeholder="Default Seating Start"
                            onChange={handleChange('defaultSeatingStartTime')}
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <InputField
                            label="Default Seating End"
                            variant="outlined"
                            id="time"
                            type="time"
                            value={defaultSeating.defaultSeatingEndTime}
                            placeholder="Default Seating End"
                            onChange={handleChange('defaultSeatingEndTime')}
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <FormControl variant="outlined">
                            <InputLabel shrink>Price model</InputLabel>
                            <Select
                                input={<OutlinedInput notched label="Price model" />}
                                label='Price model'
                                variant='outlined'
                                value={defaultSeating.defaultSeatingPriceModelId}
                                onChange={handlePriceModelChange("defaultSeatingPriceModelId")}
                                fullWidth
                            >
                                {priceModelsView}
                            </Select>
                        </FormControl>
                    </InputContainer>
                    <div className={classes.defaultDishContainer}>
                        <div>
                            <div className={classes.inputTitle}>Default Dishes</div>
                            <div>
                                {defaultDishesView}
                            </div>
                        </div>
                    </div>
                    <CancelCrudButtons 
                        hidden={defaultSeatingHidden} 
                        setHidden={setDefaultSeatingHidden} 
                        isDelete={false} 
                        postEntity={createDefaultSeating}
                        postButtonText={defaultSeating.defaultSeatingId !== '' ? "Update " : "Create " + "default seating"} />
                </div>
                :
                <></> // Empty tag if no default seating
            }
        </Modal>   
    );
}